import _ from 'lodash';
import Service from './abstract';

const defaultWith = 'type,attributes,attributes.attribute';
const defaultOptionsFind = {
    order: 'created_at-DESC',
    with: defaultWith,
    pageSize: 10
};

class Products extends Service {
    constructor () {
        super('products');
    }

    get fullWith () {
        return defaultWith;
    }

    get defaultOptionsFind () {
        return _.merge({}, super.defaultOptionsFind, defaultOptionsFind);
    }
}

export default new Products();
